// Live airport rooms (DFW / Love Field) — shared by the hero badge and the
// tonight ticker. Polls the public venue directory every 45s. Empty array
// means "no airport rooms open" — callers hide themselves in that case.
import { useEffect, useState } from "react";
import { getVenueDirectory } from "@/lib/api";

export const isAirportVenue = (v) =>
  /airport|love field|dfw/i.test(
    `${v.name || ""} ${v.slug || ""} ${v.neighborhood || ""}`
  );

export function useLiveAirports() {
  const [live, setLive] = useState([]);
  useEffect(() => {
    let cancel = false;
    const load = () =>
      getVenueDirectory()
        .then((list) => {
          if (cancel) return;
          setLive(
            (list || []).filter(
              (v) => (v.live_now || 0) > 0 && isAirportVenue(v)
            )
          );
        })
        .catch(() => {});
    load();
    const t = setInterval(load, 45000);
    return () => {
      cancel = true;
      clearInterval(t);
    };
  }, []);
  return live;
}
